import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const StickyEnquire = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.9);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          data-testid="sticky-enquire-button"
          initial={{ opacity: 0, y: 24, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.9 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          onClick={() => scrollToId("#contact")}
          className="hidden md:flex fixed bottom-7 right-7 z-40 items-center gap-2.5 rounded-full bg-[#1C1417]/90 backdrop-blur-md text-[#FAF7F5] border border-white/15 pl-6 pr-5 py-3.5 font-mono text-[11px] uppercase tracking-[0.22em] shadow-[0_20px_50px_-15px_rgba(28,20,23,0.6)] hover:bg-[#A31D4F] hover:border-[#A31D4F] transition-colors duration-400"
        >
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#D84A75] opacity-60" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#D84A75]" />
          </span>
          Enquire
          <ArrowUpRight size={14} />
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default StickyEnquire;
